<template>
  <div class="pc_footer_box">
    <div class="pc_footer_ensure_box">
      <div class="pc_footer_ensure_list clearfix_">
        <div @click="goto(item)" v-for="(item,index) in footerData" :key="index" class="pc_footer_ensure_item fl clearfix_">
          <div class="fl pc_footer_ensure_item_img"><img :src="item.pic" alt=""></div>
          <div class="fl pc_footer_ensure_item_txt">{{item.title}}</div>
          <div class="fr pc_footer_ensure_item_decorate">|</div>
        </div>
      </div>
    </div>
    <div class="pc_footer_bottom_box clearfix_">
      <div v-for="(item,index) in indexBottomData" :key="index" class="pc_footer_bottom_item fl">
        <div @click="gotoArticlList(item.category.id)" class="pc_footer_bottom_item_name">{{item.category.name}}</div>
        <div class="pc_footer_bottom_val_list">
          <div @click="goToArticlItem(val.id)" v-for="(val,idx) in item.articl" :key="idx" class="pc_footer_bottom_val">{{val.title}}</div>
        </div>
      </div>
    </div>
    <div id="pc_footer_jurisdiction" class="pc_footer_jurisdiction"></div>
  </div>
</template>

<style scoped>
.pc_footer_box{
  width: 100%;
  padding-bottom: 20px;
  background: #fff;
}
.pc_footer_ensure_box{
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
}
.pc_footer_ensure_list{
  width: 1120px;
  margin: 0 auto;
}
.pc_footer_ensure_item{
  width: 180px;
  line-height: 46px;
  padding: 0 22px;
  cursor: pointer;
}
.pc_footer_ensure_item_img{
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.pc_footer_ensure_item_img img{
  width: 30px;
  height: 30px;
}
.pc_footer_ensure_item_txt{
  line-height: 30px;
  width: 100px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.pc_footer_ensure_item_decorate{
  line-height: 30px;
  margin-right: 27px;
}
.pc_footer_ensure_item:last-child .pc_footer_ensure_item_decorate{
  display: none;
}
.pc_footer_bottom_box{
  width: 1076px;
  margin: 0 auto;
  margin-bottom: 20px;
  padding: 0 22px;
  padding-top: 36px;
}
.pc_footer_bottom_item{
  width: 20%;
}
.pc_footer_bottom_item_name{
  width: 80%;
  font-size: 14px;
  color: #333;
  margin-bottom: 15px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.pc_footer_bottom_val{
  width: 80%;
  color: #666;
  margin-bottom: 15px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.pc_footer_jurisdiction{
  width: 80%;
  text-align: center;
  margin: 0 auto;
  line-height: 18px;
}








</style>

<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return{
      indexBottomData:[],
      footerData:[]
    }
  },
  computed:{
  },
  mounted:function(){
    var t_=this
    var allData=JSON.parse(localStorage.getItem('indexAllData'))
    allData.forEach(function(item,index){
      if(item.parentName=='footerEnsure')t_.footerData=item.content
    })
    var data=JSON.parse(localStorage.getItem('pcFooterData'))
    t_.indexBottomData=data.bottomarticles
    $('.pc_footer_jurisdiction').html(data.recordNamber)
    $('.pc_footer_jurisdiction a').hover(function(){
      $(this).css({'color':'#fa0'})
    },function(){
      $(this).css({'color':'#222'})
    })
  },
  methods:{
    gotoArticlList:function(id){
      var href=this.$router.resolve({name:'articleList',query:{_id:id}})
      window.open(href.href,'_blank')
    },
    goToArticlItem:function(id,_id){
      var href=this.$router.resolve({name:'articleList',query:{id:id}})
      window.open(href.href,'_blank')
    },
    goto:function(obj){
      var t_ = this
      if( obj.status==1 ){
        if(obj.atriceId=='')return
        var href=this.$router.resolve({
          name:'articleList',
          query: {
            id: obj.atriceId
          }
        })
        window.open(href.href,'_blank')
      }else if(obj.status==2){
        var href=this.$router.resolve({
          name:'goodslist',
          query: {
            id: obj.categoryId
          }
        })
        window.open(href.href,'_blank')
      }else if(obj.status==3){
        var href=this.$router.resolve({
          name:'goodslist',
          query: {
            txt: obj.search
          }
        })
        window.open(href.href,'_blank')
      }else if(obj.status==5){
        //window.location.open = obj.link
        window.open(obj.link)
      }else if(obj.status==6){
        var href=t_.$router.resolve({
          name:'goodsdetails',
          query:{
            goodsId:obj.goodsId,
            isSupplyChainGoods:2,
            supplyChainTenantId:obj.supplyChainTenantId
          }
        })
        window.open(href.href,'_blank')
      }else if(obj.status==4){
        var href=t_.$router.resolve({
          name:obj.formwordPcLocal,
          query:{
            id:obj.formwordId
          }
        })
        window.open(href.href,'_blank')
      }else if(obj.status==9){
        if(obj.module==1){
          var href=this.$router.resolve({name:'teamGoods'});
          window.open(href.href,'_blank')
        }else if(obj.module==3){
          var href=this.$router.resolve({name:'couponList'});
          window.open(href.href,'_blank')
        }else if(obj.module==5){
          var href=this.$router.resolve({name:'activityList'});
          window.open(href.href,'_blank')
        }else if(obj.module==6){
          var href=this.$router.resolve({name:'scoreChange'});
          window.open(href.href,'_blank')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index/pcFooter.vue